import { Offer } from "@/schemas/firestore/offer.schema";
import { Persona } from "@/schemas/firestore/persona.schema";
import { Timestamp } from "firebase/firestore";

const GENERATION_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes

export function hasActivePendingPersonas(personas: Persona[]): boolean {
  // Defensive check: if personas array is empty or undefined, return false
  if (!personas || personas.length === 0) {
    return false;
  }

  const activePendingPersonas = personas.filter((persona) => {
    if (persona.status !== "pending") return false;

    // Check if generation is stale (older than timeout)
    if (persona.created_at && isGenerationStale(persona.created_at)) {
      return false;
    }

    return true;
  });

  return activePendingPersonas.length > 0;
}

export function hasActivePendingOffers(offers: Offer[]): boolean {
  // Defensive check: if offers array is empty or undefined, return false
  if (!offers || offers.length === 0) {
    return false;
  }

  const activePendingOffers = offers.filter((offer) => {
    if (offer.status !== "pending") return false;

    // Check if generation is stale (older than timeout)
    if (offer.created_at && isGenerationStale(offer.created_at)) {
      return false;
    }

    return true;
  });

  return activePendingOffers.length > 0;
}

export function isGenerationStale(createdAt: Date | Timestamp): boolean {
  const now = new Date();
  const createdAtDate =
    createdAt instanceof Timestamp ? createdAt.toDate() : createdAt;
  const timeDiff = now.getTime() - createdAtDate.getTime();
  return timeDiff > GENERATION_TIMEOUT_MS;
}

export function getActivePendingPersonas(personas: Persona[]): Persona[] {
  return personas.filter((persona) => {
    if (persona.status !== "pending") return false;

    // Exclude stale generations
    if (persona.created_at && isGenerationStale(persona.created_at)) {
      return false;
    }

    return true;
  });
}

export function getActivePendingOffers(offers: Offer[]): Offer[] {
  return offers.filter((offer) => {
    if (offer.status !== "pending") return false;

    // Exclude stale generations
    if (offer.created_at && isGenerationStale(offer.created_at)) {
      return false;
    }

    return true;
  });
}
